import countries from "i18n-iso-countries";
import deLocale from "i18n-iso-countries/langs/de.json";
import enLocale from "i18n-iso-countries/langs/en.json";
import esLocale from "i18n-iso-countries/langs/es.json";

// Have to register the languages you want to use
countries.registerLocale(deLocale);
countries.registerLocale(enLocale);
countries.registerLocale(esLocale);

export default countries;
